export const sessionStorageKey = {
  passwordResetEmail: 'password-reset-email',
};

/** Shared email format regex used by login and forgot-password validation. */
export const EMAIL_FORMAT_RE =
  /^[a-zA-Z0-9.!#$%&'*+/=?^_`{|}~-]+@[a-zA-Z\d](?:[a-zA-Z\d-]{0,61}[a-zA-Z\d])?(?:\.[a-zA-Z\d](?:[a-zA-Z\d-]{0,61}[a-zA-Z\d])?)+$/;
